// Vendor Libraries
import { setPreferenceIndicesCalcs } from './family-indices-table.action';
// NgRx actions / selectors
import { createReducer, on } from '@ngrx/store';
// Edit columns modal reducers
export const preferenceIndicesCalcs = createReducer([], on(setPreferenceIndicesCalcs, (state, action) => {
    return action.calcs;
}));
